<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">12<span class="smallcaps">TH </span>A<span class="smallcaps">PRIL </span>1974</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-april-dead_00004.vue?26bb1cb8